import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import navigation_45global from "/app/src/middleware/navigation.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  navigation_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/src/middleware/auth.ts"),
  "paypay-callback": () => import("/app/src/middleware/paypay.callback.ts")
}